import React from 'react';
import { useRecoilState } from 'recoil';
import { useAssessmentsContext } from '@/components/context/hooks/AssessmentsContext';
import { usePaginationContext } from '@/components/context/hooks/PaginationContext';
import { scanFilterState } from '@/recoil/atoms/scanFilterAtom';
import { MultiSelectFilter } from './MultiSelectFilter';

interface AssessmentFilterProps {
    disabled?: boolean;
}

export const AssessmentFilter = (props: AssessmentFilterProps) => {
    const { disabled } = props;
    const { assessmentsDict } = useAssessmentsContext();
    const assessments = assessmentsDict ? Object.values(assessmentsDict) : [];
    assessments.sort((a, b) => a.id.localeCompare(b.id));
    const [scanFilters, setScanFilters] = useRecoilState(scanFilterState);
    const { page, setPage } = usePaginationContext();

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (page !== 1) {
            setPage(1);
        }
        const currentAssessments = [...scanFilters.assessmentIds];
        if (event.target.checked) {
            setScanFilters({
                ...scanFilters,
                assessmentIds: [...currentAssessments, event.target.name],
            });
        } else {
            const i = currentAssessments.indexOf(event.target.name);
            if (i > -1) {
                currentAssessments.splice(i, 1);
            }
            setScanFilters({
                ...scanFilters,
                assessmentIds: currentAssessments,
            });
        }
    };

    const handleClearSelection = () => {
        if (page !== 1) {
            setPage(1);
        }
        setScanFilters({
            ...scanFilters,
            assessmentIds: [],
        });
    };

    return (
        <MultiSelectFilter
            selected={scanFilters.assessmentIds.map((key) => {
                return key.toString();
            })}
            options={assessments.map((assessment) => {
                return {
                    id: assessment.id,
                    name: `${assessment.id} - ${assessment.name}`,
                };
            })}
            disabled={disabled}
            handleRadioChange={handleRadioChange}
            handleClearSelection={handleClearSelection}
            label="Assessments"
            prefix="Assessments"
        />
    );
};
